module.exports = __webpack_public_path__ + "img/TH.0efa704a.webp";